import { render, staticRenderFns } from "./Page_2.vue?vue&type=template&id=c7fd6416&"
import script from "./Page_2.vue?vue&type=script&lang=js&"
export * from "./Page_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports